<div class="row">
  <div class="col-md-12">
    <h3 class="text-center"><span [innerHTML]="'AccountSettings.BusinessDetails' | translate | htmlSafe"></span></h3>
    <div class="col-md-8 offset-md-1">
      <div class="form-group row">
        <label class="col-md-4 col-form-label control-label-3"
               for="businessName"><span [innerHTML]="'AccountSettings.businessName' | translate | htmlSafe"></span></label>
        <div class="col-md-8">
          <input type="text" class="form-control" id="businessName" value=""
                 [ngModel]="business.businessName">
        </div>
      </div>
      <div class="clearfix clear-spacing" *ngIf="configList['enterpriseChild']"></div>
      <div class="form-group row" *ngIf="configList['enterpriseChild']">
        <label class="col-md-4 control-label-3"><span>Business Internal Display Name:</span></label>
        <div class="col-md-8">
          <input type="text" class="form-control" value="" [ngModel]="business.internalName">
        </div>
      </div>
      <div class="clearfix clear-spacing" *ngIf="configList['enterpriseChild']"></div>
      <div class="form-group row" *ngIf="configList['enterpriseChild']">
        <label class="col-md-4 control-label-3"><span>Business Team Name:</span></label>
        <div class="col-md-8">
          <input type="text" class="form-control" value="" [ngModel]="business.teamName">
        </div>
      </div>
      <div class="clearfix clear-spacing"
           *ngIf="configList['enterpriseChild'] && configList['allowBusinessExternalId']"></div>
      <div class="form-group row"
           *ngIf="configList['enterpriseChild'] && configList['allowBusinessExternalId']">
        <label class="col-md-4 control-label-3"><span>External ID:</span></label>
        <div class="col-md-8">
          <input type="text" class="form-control" value="" [ngModel]="business.externalId">
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>
      <div class="form-group row">
        <label class="col-md-4 control-label-3" for="timezones">Allowed Backoffice Timezones:</label>
        <div class="col-md-8">
          <mat-select aria-label="Select Timezones to Allow" multiple id="timezones"
                      placeholder="Select Timezones to Allow" [ngModel]="allowedTimezones">
            @for (tz of timezones; track tz) {
              <mat-option [value]="tz">{{ tz.timeZoneDesc }}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>
      <div class="form-group row">
        <label class="col-md-4 control-label-3" for="businessTz"><span
        >{{ 'AccountSettings.timezone' | translate }}</span></label>
        <div class="col-md-8">
          <mat-select id="businessTz" [ngModel]="business.timeZone.timeZoneId"
                      placeholder="Select Business Timezone" aria-label="Select Business Timezone">
            @for (btz of allowedTimezones; track btz) {
              <mat-option [value]="btz.timeZoneId">{{ btz.timeZoneDesc }}</mat-option>
            }
          </mat-select>
        </div>
      </div>

      <div class="clearfix clear-spacing"
           *ngIf="business.plan.planCode === 'TTFREE' || business.plan.planCode === 'TTPLUS'"></div>
      <div class="form-group row"
           *ngIf="business.plan.planCode === 'TTFREE' || business.plan.planCode === 'TTPLUS'">
        <label
          class="col-md-4 control-label-3"><span>{{ 'modal.ServiceSettingsCurrency' | translate }}
          :</span></label>
        <div class="col-md-8">
          <!--<select name="currency" id="currency" class="form-control" [ngModel]="business.currency"
                  ng-options="currency.currencyName for currency in currencies"></select>-->
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>
      <div class="form-group row">
        <label class="col-md-4 control-label-3">Show Payments:</label>
        <div class="col-md-8">
          <mat-checkbox [ngModel]="configList['showPayments']"></mat-checkbox>
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>
      <div class="form-group row">
        <label class="col-md-4 control-label-3">Display Times in 24 Hour Format:</label>
        <div class="col-md-8">
          <mat-checkbox [ngModel]="configList['showTimes24HourFormat']"></mat-checkbox>
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>

      <div class="form-group row">
        <label class="col-md-4 control-label-3"
               for="businessCountry"><span>{{ 'modal.editLocationCountry' | translate }}
          </span></label>
        <div class="col-md-8">
          <mat-select id="businessCountry"
                      placeholder="Select Business Country" aria-label="Select Business Country" [ngModel]="business.country.countryId">
            @for (country of countries; track country) {
              <mat-option [value]="country.countryId">{{ country.country }}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>
      <div class="form-group row">
        <label class="col-md-4 control-label-3" for="businessLocale"><span>Locale:</span></label>
        <div class="col-md-8">
          <mat-select id="businessLocale"
                      placeholder="Select Business Locale" aria-label="Select Business Locale"
                      matTooltip="Locale helps to determine the default language for your business (if you have your
                              scheduler or email templates translated in multiple languages) as well as the date
                              format. While en-US and en-GB are both set to English language, a business who is set to
                              en-US will, by default, get emails with the dates set as MM/DD/YYYY whereas a business
                              who is set to en-GB will get emails with the date formatted as DD/MM/YYYY. If you know
                              the country as well as the language, please select the option that reflects both."
          [ngModel]="business.locale">
            @for (locale of locales; track locale) {
              <mat-option [value]="locale.localeName">{{ locale.localeDescription }}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>
      <div class="form-group row">
        <label
          class="col-md-4 control-label-3" for="clientLabel"><span>Term for people booking with you:</span></label>
        <div class="col-md-6">
          <mat-select id="clientLabel"
                      placeholder="Select Term" aria-label="Select Term for people booking with you" [value]="configList['clientLabelPlural']">
            @for (label of clientLabelList; track label) {
              <mat-option [value]="label.plural">{{ label.plural }}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>
      <div class="form-group row">
        <label class="col-md-4 control-label-3" for="staffLabel"><span>Term for people accepting appointments:</span></label>
        <div class="col-md-6">
          <mat-select id="staffLabel"
                      placeholder="Select Term" aria-label="Select Term for people accepting appointments"
                      [value]="configList['staffLabelPlural']">
            @for (label of staffLabelList; track label) {
              <mat-option [value]="label.plural">{{ label.plural }}</mat-option>
            }
          </mat-select>
        </div>
      </div>

      <div class="clearfix clear-spacing"></div>

      <div class="form-group row">
        <label class="col-md-4 control-label-3"><span>{{ 'business.externalUrl' | translate }}</span></label>
        <div class="col-md-8">
          <input type="text" class="form-control" value="" [ngModel]="business.externalUrl"  matTooltip="This can be used to merge external links within messaging templates on the child
            account. Merge field tag: %BUSINESS_EXT_URL%">
        </div>
      </div>
      <div class="clearfix clear-spacing"></div>

      <div class="form-group row" *ngIf="configList['accessibilityRequired']">
        <label class="col-md-4 control-label-3">Use Accessibility Features:</label>
        <div class="col-md-8">
          <mat-checkbox id="acessibilityMode" [ngModel]="accessibleMode"></mat-checkbox>
        </div>
      </div>
      <div class="clearfix clear-spacing" *ngIf="configList['accessibilityRequired']"></div>

      <div class="form-group row">
        <div class="col-md-8 offset-md-4 text-center">
          <button type="button" class="btn btn-block tt-green-accessible">
            <mat-icon class="mat-icon-vertical">save</mat-icon>
            <span>{{ 'btn.saveChangesBusiness' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
